module.exports = __webpack_public_path__ + "img/breakfast.6fad0bbf.svg";